"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowHeightState = void 0;
var RowHeightState = (function () {
    function RowHeightState(maxBoxHeight, maxAscent, maxDescent, maxPictureBoxHeight) {
        this.maxBoxHeight = maxBoxHeight;
        this.maxAscent = maxAscent;
        this.maxDescent = maxDescent;
        this.maxPictureBoxHeight = maxPictureBoxHeight;
    }
    RowHeightState.prototype.initFromRow = function (row) {
        this.height = row.height;
        this.baseLine = row.baseLine;
        this.spacingBefore = row.getSpacingBefore();
    };
    RowHeightState.prototype.applyToRow = function (row) {
        row.rollbackSpacingBefore();
        row.applySpacingBefore(this.spacingBefore);
        row.height = this.height;
        row.baseLine = this.baseLine;
    };
    RowHeightState.prototype.getFullRowHeight = function () {
        return this.height + this.spacingBefore;
    };
    RowHeightState.prototype.equalHeights = function (obj) {
        return this.maxBoxHeight == obj.maxBoxHeight &&
            this.maxAscent == obj.maxAscent &&
            this.maxDescent == obj.maxDescent &&
            this.maxPictureBoxHeight == obj.maxPictureBoxHeight;
    };
    return RowHeightState;
}());
exports.RowHeightState = RowHeightState;
